import { IconName } from '@billy/design-system'

import { DisplayTransactionType } from '@features/bankTransactions/enums/displayTransactionType'

export const transactionTypeToIcon: Record<DisplayTransactionType, IconName> = {
  [DisplayTransactionType.Unknown]: 'sunDim',
  [DisplayTransactionType.Card]: 'creditCard',
  [DisplayTransactionType.DirectDebit]: 'arrowUp',
  [DisplayTransactionType.TransferOut]: 'arrowUpRight',
  [DisplayTransactionType.TransferIn]: 'arrowDownLeft',
  [DisplayTransactionType.WalletTransfer]: 'arrowRightLeft',
  [DisplayTransactionType.ATM]: 'banknote',
}
